import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TVHeatmapGuideStrip from './TVHeatmapGuideStrip';
import TVHeatmapGrid from './TVHeatmapGrid';
import { tvAiryGlass } from './tvBroadcastStyles';

/** 説明帯 + ヒートマップ（1枚） */
function TVStationHeatmapCard({
  rowHeader,
  rowLabels,
  colLabels,
  cells,
  compact = false,
  sizePreset = 'stationOverlay',
  airy = false,
  centerGrid = false,
  fillWidth = false,
}) {
  const glass = airy ? tvAiryGlass : null;
  const useCenter = centerGrid && !fillWidth;

  return (
    <Box
      sx={{
        width: airy ? 'min(94%, 980px)' : 'min(92%, 960px)',
        maxWidth: airy ? 'min(94%, 980px)' : 'min(92%, 960px)',
        display: 'flex',
        flexDirection: 'column',
        gap: compact ? 0.28 : airy ? 0.5 : 0.35,
        alignSelf: 'center',
        mx: 'auto',
      }}
    >
      <TVHeatmapGuideStrip compact={compact} airy={airy} />
      <Box
        sx={{
          width: '100%',
          bgcolor: airy ? glass.panel : 'rgba(255,255,255,0.88)',
          border: airy ? glass.border : '3px solid #fff',
          borderRadius: 0.5,
          boxShadow: airy ? glass.shadow : '0 4px 16px rgba(13,74,143,0.18)',
          overflow: 'hidden',
          px: airy ? 0.5 : 0,
          py: airy ? 0.45 : 0,
        }}
      >
        <TVHeatmapGrid
          rowHeader={rowHeader}
          rowLabels={rowLabels}
          colLabels={colLabels}
          cells={cells}
          compact={compact}
          fillWidth={fillWidth}
          centerGrid={useCenter}
          sizePreset={sizePreset}
          showValues
          fitContent
        />
      </Box>
    </Box>
  );
}

TVStationHeatmapCard.propTypes = {
  rowHeader: PropTypes.string,
  rowLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  colLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  cells: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  compact: PropTypes.bool,
  sizePreset: PropTypes.string,
  airy: PropTypes.bool,
  centerGrid: PropTypes.bool,
  fillWidth: PropTypes.bool,
};

export default TVStationHeatmapCard;
